import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo, useEffect, useMemo } from 'react';
import { __MUNICIPALITY_API_URL__ } from 'shell/constants/environment';
import { ItemVM } from 'shell/view-models/item';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { Region } from 'shell/models/region';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { PmiSelect } from 'shell/components/shared/pmi-select';

interface RegionListComponentProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  onBlur?: () => void;
  error?: boolean;
}

const RegionListComponent = ({
  disabled,
  onChange,
  onBlur = () => {
    return;
  },
  value,
  error,
  required,
}: RegionListComponentProps): React.ReactElement => {
  const {
    data,
    error: errorlist,
    get: getRegionListComponent,
  } = useHttpFetch<HttpResponseList<Region>>(
    `${__MUNICIPALITY_API_URL__}/geo/regione?sort=nome:ASC`,
    {
      data: {
        payload: {
          list: [],
        },
      },
    }
  );

  const list: Array<ItemVM> = useMemo(() => {
    if (!!errorlist || !data?.payload) {
      return [];
    }
    return data?.payload.list.map((item) => ({
      id: item.key.codice,
      value: item.nome,
    }));
  }, [data, errorlist]);

  useEffect(() => {
    getRegionListComponent();
  }, []);

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="region-label">
        {required ? 'Regione *' : 'Regione'}
      </InputLabel>
      <PmiSelect
        labelId="region-label"
        id="region"
        name="region"
        value={value}
        label={required ? 'Regione *' : 'Regione'}
        onChange={onChange}
        disabled={disabled}
        error={error}
        onBlur={onBlur}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {list.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

RegionListComponent.displayName = 'Region item component';

const RegionList = memo(RegionListComponent);

export default RegionList as typeof RegionListComponent;
